<template style="height:100%">
  <div class="Basic_content">

    <div class="left">
      <h2 style="font-size: 16px;padding:15px">报告版本</h2>
      <el-tree class="filter-tree" style="margin-left:15px" :data="data" default-expand-all  ref="tree" @node-click="handleNodeClick">
      </el-tree>
    </div>

    <div class="right">
      <h2 style="font-size: 16px;padding:15px">配置内容</h2>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="报告标题">
          <el-checkbox-group v-model="form.reportTitle">
            <el-checkbox label="机构名称" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="个人信息:">
          <el-checkbox-group v-model="form.userInfo">
            <!-- <el-checkbox v-for="(item,i) in data49" :key="i"  :label="item.cDicValue" :value="item.dicKey" name="type">111</el-checkbox> -->

            <el-checkbox v-for="(item,index) in data49" :key="index" :label="item.cDicEnglishValue">{{item.cDicValue}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="测验结果:">
          <el-checkbox-group v-model="form.testResult">
            <el-checkbox label="IniScore"  name="type">原始分</el-checkbox>
            <el-checkbox label="StandScore"  name="type">标准分</el-checkbox>
            <el-checkbox label="AverageScore" name="type">均分</el-checkbox>
            <el-checkbox label="ResultGrade"  name="type">参考诊断</el-checkbox>
            <el-checkbox label="AverageNumSD" name="type">常模</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="测验图表:">
          <el-checkbox-group v-model="form.chart">
            <el-checkbox label="测验图表" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="测验分析:">
          <el-checkbox-group v-model="form.testAnalysis">
            <el-checkbox label="测验分析" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="建议:">
          <el-checkbox-group v-model="form.pushContent">
            <el-checkbox label="建议" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <h2 style="font-size: 16px;padding:15px">附属内容</h2>

        <el-form-item>
          <el-checkbox-group v-model="form.accessoryContent">
            <el-checkbox label="AttachedAnswer" name="type">附答卷</el-checkbox>
            <el-checkbox label="OrderByFactor" name="type">答卷按因子排序</el-checkbox>
            <el-checkbox label="Diagnosis" name="type">结论</el-checkbox>
            <el-checkbox label="测试时间"  name="type">测验用时</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item class="hio">
          <el-checkbox-group v-model="form.a14">
            <el-checkbox label="提示" name="type"></el-checkbox>
          </el-checkbox-group>
          <el-input v-model="form.a14s" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item class="hio">
          <el-checkbox-group v-model="form.a15">
            <el-checkbox label="签名" name="type"></el-checkbox>
          </el-checkbox-group>
          <el-input v-model="form.a15s" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
        </el-form-item>

      </el-form>
    </div>
  </div>
</template>
<script>

  export default {
    data() {
      return {
        form: {
          reportTitle: [],
          testResult: [],
          chart: [],
          testAnalysis: [],
          pushContent: [],
          accessoryContent: [],
          userInfo: [],
          a14: [],
          a14s: '',
          a15: [],
          a15s: '',
          a16: [],
          a17: '',
          reportVersion: '',
          reportType: '',
        },
        data49:[],
        data: [{
          id: 'UserInfo',
          label: '通用版',
          children: [{
            id: 'Report01',
            label: '管理端报告',
            type:'UserInfo',
            children: []
          },{
            id: 'Report02',
            label: '客户端报告',
            type:'UserInfo',
            children: []
          },]
        }, {
          id: 'UserInfoArmy',
          label: '军队版',
          children: [{
            id: 'Report01',
            type:'UserInfoArmy',
            label: '管理端报告'
          }, {
            id: 'Report02',
            type:'UserInfoArmy',
            label: '客户端报告'
          }]
        }, {
          id: 'UserInfoSchool',
          label: '学校版',
          children: [{
            id: 'Report01',
            type:'UserInfoSchool',
            label: '管理端报告'
          }, {
            id: 'Report02',
            type:'UserInfoSchool',
            label: '客户端报告'
          }]
        },{
          id: 'UserInfoHospital',
          label: '医院版',
          children: [{
            id: 'Report01',
            type:'UserInfoHospital',
            label: '管理端报告'
          }, {
            id: 'Report02',
            type:'UserInfoHospital',
            label: '客户端报告'
          }]
        },{
          id: 'UserInfoPolice',
          label: '公安版',
          children: [{
            id: 'Report01',
            type:'UserInfoPolice',
            label: '管理端报告'
          }, {
            id: 'Report02',
            type:'UserInfoPolice',
            label: '客户端报告'
          }]
        },{
          id: 'UserInfoPrison',
          label: '监狱版',
          children: [{
            id: 'Report01',
            type:'UserInfoPrison',
            label: '管理端报告'
          }, {
            id: 'Report02',
            type:'UserInfoPrison',
            label: '客户端报告'
          }]
        },]
      };
    },
    components:{
      
    },
    methods: {
      handleNodeClick(data) {
        this.form.reportVersion = data.type
        this.form.reportType = data.id
        this.$Http_Post('reportCng/getReportContentCng', { reportVersion:data.type,reportType:data.id}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if(res.Data.reportTitle){
              this.form.reportTitle = res.Data.reportTitle
            }
            if(res.Data.testResult){
              this.form.testResult = res.Data.testResult
            }
            if(res.Data.chart){
              this.form.chart = res.Data.chart
            }
            if(res.Data.testAnalysis){
              this.form.testAnalysis = res.Data.testAnalysis
            }

            if(res.Data.pushContent){
              this.form.pushContent = res.Data.pushContent
            }
            if(res.Data.accessoryContent){
              this.form.accessoryContent = res.Data.accessoryContent
            }
            if(res.Data.userInfo){
              var ji = []
              for(var i = 0;i< res.Data.userInfo.length;i++){
                ji.push(res.Data.userInfo[i].name)
              } 
              this.form.userInfo = ji
            }
            if(res.Data.accessoryContent2){
              for(var i = 0;i< res.Data.accessoryContent2.length;i++){
                if(res.Data.accessoryContent2[i].key[0] == "提示"){
                  this.form.a14 = res.Data.accessoryContent2[i].key
                  this.form.a14s = res.Data.accessoryContent2[i].value
                }else{
                  this.form.a15 = res.Data.accessoryContent2[i].key
                  this.form.a15s = res.Data.accessoryContent2[i].value
                }
              }
            }
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      onSubmit() {
        if(!this.form.reportVersion){
          alert('请选择报告版本！');
          return false;
        }
        var xs =[];
        
        for(var i = 0;i< this.data49.length;i++){
          for(var j = 0;j< this.data49.length;j++){
            if(this.form.userInfo[j] == this.data49[i].cDicEnglishValue){
              xs.push(
                {
                  name:this.data49[i].cDicValue,
                  value:this.data49[i].cDicEnglishValue,
                }
              )
            }
          }
        }
        this.$Http_Post('reportCng/saveReportContentCng', { 
          reportVersion:this.form.reportVersion,
          reportType:this.form.reportType,
          reportTitle:this.form.reportTitle,
          userInfo:xs,
          testResult:this.form.testResult,
          chart:this.form.chart,
          testAnalysis:this.form.testAnalysis,
          pushContent:this.form.pushContent,
          accessoryContent:this.form.accessoryContent,
          accessoryContent2:[
            {
              key:this.form.a14,
              value:this.form.a14s,
            },
            {
              key:this.form.a15,
              value:this.form.a15s,
            },
          ],
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    mounted(){
      this.$Http_Post('User/GetDictionaryList', { DicTypCode:49}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data49 = res.Data
          console.log(this.data49)
        }else{
          this.Global.request_failure(res.Message);
        }
      });
    }
  };
</script>
<style>
.Basic_content{width: 100%;height: 100%;}
.Basic_content .left{width: 350px;height: 100%;background-color: #fff;float: left;}
.Basic_content .right{width: calc(100% - 365px);float: right;background-color: #fff;height: 100%;}
.Basic_content .el-form-item{margin-bottom:10px}
.Basic_content .hio .el-checkbox-group{width: 80px;float: left;}
.Basic_content .hio .el-input{width: 200px;}
</style>